import React from 'react';
import './subtitle.css';

export const SubTitle: React.FC<{ children: React.ReactNode; style?: string }> = ({ children, style }) => {
  return (
    <span className={`page-subtitle ${style}`}>{children}</span>
  )
}
